module.exports = __webpack_public_path__ + "img/advicebg.2befb5b5.png";